module.exports = __webpack_public_path__ + "static/media/400406_02.b70e237f.png";